import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/awg-wire-gauge-calculator',
  component: () => import('../../routes/AwgWireCalculator.svelte'),
  card: {
    id: 'awg-wire',
    title: 'AWG Wire Gauge Calculator',
    description: 'Find the correct American Wire Gauge (AWG) size for your electrical project. Calculates wire gauge from current, checks voltage drop, and displays NEC ampacity ratings.',
    icon: 'electrical_services',
    iconBgClass: 'bg-yellow-50',
    iconTextClass: 'text-yellow-600',
    href: '/awg-wire-gauge-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'AWG Wire Gauge Calculator – Find Correct Wire Size from Amps',
    description:
      'Free AWG wire gauge calculator to find the correct wire size for any current. Calculates voltage drop, NEC ampacity ratings, and resistance per 1000 ft for copper wire.',
  },
};

export default meta;
